import React from 'react';
import { TextInputFormField } from '../../../../../components/Fieldset/TextInputFormField';
import { getMaxBirthDate, getMinBirthDate } from '../../../../../services/common/validation';
import { DatePickerFormField } from '../../../../../components/Fieldset/DatePickerFormField';

export const searchFormInputs = () => {
  return {
    firstName: () => (
      <TextInputFormField
        fieldName="firstName"
        labelTranslationKey="customerSearchModal:private:fields:firstName:label"
        placeholderTranslationKey="customerSearchModal:private:fields:firstName:placeholder"
      />
    ),
    lastName: () => (
      <TextInputFormField
        fieldName="lastName"
        labelTranslationKey="prospectPage:private:fields:lastName:label"
        placeholderTranslationKey="prospectPage:private:fields:lastName:placeholder"
      />
    ),
    dateOfBirth: () => (
      <DatePickerFormField
        fieldName="dateOfBirth"
        labelTranslationKey="customerSearchModal:private:fields:dateOfBirth:label"
        placeholderTranslationKey="customerSearchModal:private:fields:dateOfBirth:placeholder"
        maxDate={getMaxBirthDate()}
        minDate={getMinBirthDate()}
      />
    ),
    email: () => (
      <TextInputFormField
        fieldName="email"
        labelTranslationKey="customerSearchModal:private:fields:email:label"
        placeholderTranslationKey="customerSearchModal:private:fields:email:placeholder"
        validateOnChange
      />
    ),
  };
};
